"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesContainer = exports.default = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const categories_component_1 = require("./categories.component");
// this is temporary while work on EN-3049 is in progress
// when EN-3049 is complete, Categoriesv2 will replace Categories
const localization_1 = require("../../../localization");
const State = __importStar(require("../../../store"));
const store_1 = require("../../../store");
const const_1 = require("../../../store/const");
const CategoriesContainer = ({ openCategories, setOpenCategories, debouncedSearchTerm, isCategoriesLoading, className, categoryTotals, isProductCountsLoading, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const topLevelCategories = (0, store_1.useTopLevelCategoriesSelector)();
    const categoriesMap = (0, store_1.useCategoriesMapSelector)();
    const includedCategoriesIds = (0, store_1.useProductsIncludedCategoriesIds)();
    const excludedCategoriesIds = (0, store_1.useProductsExcludedCategoriesIds)();
    const refinementsData = (0, store_1.useRefinementsDataSelector)();
    const refinementsFilter = (0, store_1.useRefinementsFilterSelector)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isLoading = isCategoriesLoading || isProductCountsLoading;
    const getTitle = (0, react_1.useCallback)(({ subCategory }) => {
        const isCategoryUncategorized = subCategory.id === const_1.UNCATEGORIZED_ID;
        const title = isCategoryUncategorized ? (t({ key: 'UNCATEGORIZED' })) : subCategory.title;
        return title;
    }, [t]);
    const getSubCategories = (0, react_1.useCallback)((categories) => (0, ramda_1.flatten)(categories.map((category) => category.subcategoryIds.map((subCategoryId) => categoriesMap[subCategoryId]))), [categoriesMap]);
    const expansionCategories = (0, react_1.useMemo)(() => {
        const result = [];
        let subCategories = topLevelCategories;
        while (subCategories.length) {
            const title = t({ key: 'CATEGORY_LEVEL', values: { level: result.length + 1 } });
            result.push({
                id: title,
                title,
                subCategories,
            });
            subCategories = getSubCategories(subCategories);
        }
        return result;
    }, [topLevelCategories, t, getSubCategories]);
    const filteredExpansionCategories = (0, react_1.useMemo)(() => expansionCategories
        .map((category) => {
        const subCategories = category.subCategories.reduce((acc, subCategory) => {
            var _a;
            const subCategoryId = subCategory.id;
            const isMatchesFilter = refinementsFilter === State.AvailableRefinementType.Matches;
            const isSearchTermInTitle = subCategory.title.toLowerCase().includes(debouncedSearchTerm.toLowerCase());
            const isInRefinements = (_a = refinementsData === null || refinementsData === void 0 ? void 0 : refinementsData.categoryIds) === null || _a === void 0 ? void 0 : _a.includes(subCategoryId);
            const isInIncludedCategoriesIds = includedCategoriesIds.includes(subCategoryId);
            const isInExcludedCategoriesIds = excludedCategoriesIds.includes(subCategoryId);
            const isMatch = isInRefinements || isInIncludedCategoriesIds || isInExcludedCategoriesIds;
            const isShown = isMatchesFilter ? isMatch : true;
            if (isShown && isSearchTermInTitle) {
                return [
                    ...acc,
                    Object.assign(Object.assign({}, subCategory), { title: getTitle({ subCategory, isMatch }), total: categoryTotals[subCategoryId] }),
                ];
            }
            return acc;
        }, []);
        const sortedSubCategories = (0, ramda_1.flatten)((0, ramda_1.partition)((0, ramda_1.propEq)('id', const_1.UNCATEGORIZED_ID), subCategories) // set Uncategorized to the top
        );
        return Object.assign(Object.assign({}, category), { subCategories: sortedSubCategories });
    })
        .filter((category) => !(0, ramda_1.isEmpty)(category.subCategories)), [
        debouncedSearchTerm,
        expansionCategories,
        refinementsFilter,
        refinementsData === null || refinementsData === void 0 ? void 0 : refinementsData.categoryIds,
        includedCategoriesIds,
        excludedCategoriesIds,
        getTitle,
        categoryTotals,
    ]);
    const handleHeaderClick = (0, react_1.useCallback)((id) => setOpenCategories((0, ramda_1.assoc)(id, !openCategories[id], openCategories)), [openCategories, setOpenCategories]);
    const handleExpandAll = (0, react_1.useCallback)(() => setOpenCategories(expansionCategories.reduce((acc, category) => (Object.assign(Object.assign({}, acc), { [category.id]: true })), {})), [expansionCategories, dispatch]);
    const handleCollapseAll = (0, react_1.useCallback)(() => setOpenCategories({}), [setOpenCategories]);
    (0, react_1.useEffect)(() => {
        if (expansionCategories === null || expansionCategories === void 0 ? void 0 : expansionCategories.length) {
            dispatch((0, store_1.categoriesSetCategoryGroups)(expansionCategories));
        }
    }, [expansionCategories, dispatch]);
    return (react_1.default.createElement(categories_component_1.Categories, { className: className, expansionCategories: filteredExpansionCategories, onCollapseAll: handleCollapseAll, onExpandAll: handleExpandAll, onHeaderClick: handleHeaderClick, openCategories: openCategories, isCategoriesLoading: isLoading }));
};
const MemoizedCategoriesContainer = react_1.default.memo(CategoriesContainer);
exports.default = MemoizedCategoriesContainer;
exports.CategoriesContainer = MemoizedCategoriesContainer;
